module.exports = __webpack_public_path__ + "static/img/refund.f1e27706.png";